<template>
  <div class="view-container">
    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="handleClose">
      <BjDivider>{{ $t('billingPage.expenseManage') }} </BjDivider>
      <el-form v-if="drawer" ref="form" label-position="top" :model="form" :rules="rules" label-width="160px" style="padding:16px;">
        <el-col :span="24">
          <el-form-item :label="$t('billingPage.expenseLabour')" prop="officeLabour">
            <BjInputMoney v-model="form.officeLabour" :maxlength="10" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('billingPage.expenseExpense')" prop="officeExpense">
            <BjInputMoney v-model="form.officeExpense" :maxlength="10" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('billingPage.expenseWareh')" prop="warehouseExpense">
            <BjInputMoney v-model="form.warehouseExpense" :maxlength="10" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('billingPage.expenseDate')" prop="expenseDate">
            <BjDateRangePicker v-model="queryParamsTime" :placeholder="$t('billingPage.expenseDate')" />
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="danger" @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onComfirm">{{ $t('okText') }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>

export default {
  data() {
    return {
      // 表单参数
      drawer: false,
      queryParamsTime:[],
      form: {
        officeLabour:null,
        officeExpense:null,
        warehouseExpense:null,
        startDate:null,
        endDate:null,
      },
    };
  },
  computed: {
    rules() {
      const validateExDate = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.startDate || !this.form.endDate) {
            callback(new Error(this.$t('chooseText')));
          }
          callback();
        });
      };
      return {
        officeLabour: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        officeExpense: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        warehouseExpense: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        expenseDate: { required: true, validator: validateExDate, trigger: 'change' },
      };
    },
  },
  watch: {
    queryParamsTime(v) {
      this.form.startDate = (v || [])[0];
      this.form.endDate = (v || [])[1];
    },
  },
  methods: {
    // 确定按钮
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const obj = Object.assign({}, this.form);
          this.$emit('handleConfirm', obj);
        }
      });
    },
    /** 关闭弹窗 */
    handleClose() {
      this.queryParamsTime = [],
      this.form = {
        officeLabour:null,
        officeExpense:null,
        warehouseExpense:null,
        startDate:null,
        endDate:null,
      };
      this.drawer = false;
      this.$refs.form.resetFields();
    },
  },
};
</script>
<style lang="scss">
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
